// extracted by mini-css-extract-plugin
export default {"title_container":"Title_title_container__DkPEw","title":"Title_title__A0Zna"};